import { render } from "./CustomModal.vue?vue&type=template&id=020b7d88&ts=true"
import script from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomModal.vue?vue&type=style&index=0&id=020b7d88&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/CustomModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "020b7d88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('020b7d88', __exports__)) {
    api.reload('020b7d88', __exports__)
  }
  
  module.hot.accept("./CustomModal.vue?vue&type=template&id=020b7d88&ts=true", () => {
    api.rerender('020b7d88', render)
  })

}


export default __exports__